import angular from 'angular';
import Navbar from './navbar/navbar';
import Hero from './hero/hero';
import User from './user/user';

let commonModule = angular.module('app.common', [
  Navbar,
  Hero,
  User
])
  
.name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js